module.exports = __webpack_public_path__ + "img/expand-03.d9778ca8.svg";